import { CmsObjectWithDefault } from '@components/Cms/types';

export type PhoneSignupFormViewCmsKey =
    | 'phonenumberLabel'
    | 'passwordLabel'
    | 'sendOtp'
    | 'yourPolicy'
    | 'pleaseAccept'
    | 'checkAll'
    | 'checkTermsOfService'
    | 'required'
    | 'checkPrivacyPolicy'
    | 'checkThirdPartyPrivacy'
    | 'link'
    | 'sendMeOffersPhoneNumber';

export const PhoneSignupFormViewCmsWithDefault: CmsObjectWithDefault<PhoneSignupFormViewCmsKey> = {
    phonenumberLabel: {
        cmsId: 82026,
        defaultTranslation: 'Mobile number',
    },
    passwordLabel: {
        cmsId: 76296,
        defaultTranslation: 'Password',
    },
    sendOtp: {
        cmsId: 97925,
        defaultTranslation: 'Send OTP',
    },
    yourPolicy: {
        cmsId: 139901,
        defaultTranslation: 'Your data privacy policy',
    },
    pleaseAccept: {
        cmsId: 139902,
        defaultTranslation: 'Please accept all privacy policy consent to process the booking',
    },
    checkAll: {
        cmsId: 139968,
        defaultTranslation: 'I consent to all of below privacy policy',
    },
    checkTermsOfService: {
        cmsId: 139903,
        defaultTranslation: 'I agree to the Terms of Service, and I confirm that I am 18 years or older',
    },
    required: {
        cmsId: 139904,
        defaultTranslation: '[Required]',
    },
    checkPrivacyPolicy: {
        cmsId: 139905,
        defaultTranslation:
            'I consent to the collection and use of my personal information in accordance with the Privacy Policy',
    },
    checkThirdPartyPrivacy: {
        cmsId: 139906,
        defaultTranslation:
            'I consent to the third-party provision, either in Korea or overseas, of my personal information in accordance with the Privacy Policy',
    },
    link: {
        cmsId: 139907,
        defaultTranslation: '(Link)',
    },
    sendMeOffersPhoneNumber: {
        cmsId: 97945,
        defaultTranslation: 'Send me special offers and promotions',
    },
};
